import { render, staticRenderFns } from "./RelatorioPeriodo.vue?vue&type=template&id=7f7fa1b4&scoped=true"
import script from "./RelatorioPeriodo.vue?vue&type=script&lang=js"
export * from "./RelatorioPeriodo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f7fa1b4",
  null
  
)

export default component.exports